export default __webpack_public_path__ + "static/media/IMG_2756cropped.c4e8c3ae.jpeg";